import { FC } from 'react';

import { GridContentProps } from '../types/grid';
import GridContent from './GridContent';

const GridContentCentered: FC<GridContentProps> = ({ children, sx }) => (
  <GridContent sx={{ ...sx, textAlign: 'center' }}>{children}</GridContent>
);

export default GridContentCentered;
